import { Injectable, signal } from '@angular/core';
import { SubscriberCGVM } from '../models/model/concretes/components/subscriber-cg.model';

export interface NavigationState {
  groupIndex: number;
  stepNumber: number;
  isStepValid: boolean;
  subscriberCGVm: SubscriberCGVM | null;
  url: string | undefined;
}

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  state = signal<NavigationState>({
    groupIndex: 0,
    stepNumber: 0,
    isStepValid: false,
    subscriberCGVm: null,
    url: '',
  });

  formSubmitted = false;

  constructor() {}

  setNavigationState(newState: NavigationState) {
    this.state.set(newState);
  }

  getNavigationState(): NavigationState {
    return this.state();
  }

  updateGroupIndex(groupIndex: number) {
    const currentState = this.state();
    this.state.set({ ...currentState, groupIndex });
  }

  updateStepNumber(stepNumber: number) {
    const currentState = this.state();
    this.state.set({ ...currentState, stepNumber });
  }

  updateStepValidity(isStepValid: boolean) {
    const currentState = this.state();
    this.state.set({ ...currentState, isStepValid });
  }

  isStepValid(): boolean {
    return this.state().isStepValid;
  }

  updateSubmitted(value: boolean) {
    this.formSubmitted = value;
  }

  updateSubscriberCGVM(subscriberCGVm: SubscriberCGVM | null) {
    const currentState = this.state();
    this.state.set({ ...currentState, subscriberCGVm });
  }

  subscriberCGVMIsValid(): SubscriberCGVM | null {
    return this.state().subscriberCGVm;
  }

  initSubscriberCGVMIsValid() {
    this.updateSubscriberCGVM(null);
  }

  getUrl(): string | undefined {
    return this.state().url;
  }
}
